module.exports = __webpack_public_path__ + "img/background-home-desktop.796a83e7.jpg";